import { render, staticRenderFns } from "./freightDetail.vue?vue&type=template&id=85c4ea44&scoped=true"
import script from "./freightDetail.vue?vue&type=script&lang=ts"
export * from "./freightDetail.vue?vue&type=script&lang=ts"
import style0 from "./freightDetail.vue?vue&type=style&index=0&id=85c4ea44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c4ea44",
  null
  
)

export default component.exports